



































































































































































































































































import {Component, Prop} from 'vue-property-decorator'
import {TBridgeHistory} from '@/model/bridge/types/BridgeHistory'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {wallet} from '@cityofzion/neon-core'
import {BridgeNetworkHelper} from '@/helpers/BridgeNetworkHelper'
import {BridgeTokenIconHelper} from '@/helpers/BridgeTokenIconHelper'

@Component({})
export default class BridgeHistoryScrollableTable extends MixinScreenSize {
  @Prop({type: Array, required: true}) data!: TBridgeHistory[]
  @Prop({type: Boolean, required: true}) isDepositSelected!: boolean

  transactionUrl(txId: string): string {
    return this.isDepositSelected
      ? `${BridgeNetworkHelper.n3ExplorerUrl()}transactionInfo/${txId}`
      : `${BridgeNetworkHelper.xExplorerUrl()}tx/${txId}`
  }

  addressFormatted(direction: 'from' | 'to', hex: string) {
    let address

    if (
      (direction === 'from' && this.isDepositSelected) ||
      (direction === 'to' && !this.isDepositSelected)
    ) {
      address = wallet.getAddressFromScriptHash(this.cleanHexPrefix(hex))
    } else {
      address = hex
    }

    const formattedAddress = address?.trim()
      ? `${address.trim().slice(0, 5)}...${address.trim().slice(-5)}`
      : null

    return {
      address,
      formattedAddress,
    }
  }

  cleanHexPrefix(hex: string): string {
    return hex.startsWith('0x') ? hex.slice(2) : hex
  }

  tokenImage(symbol: string) {
    return BridgeTokenIconHelper.forSymbol(symbol)
  }

  timeFormatted(timestamp: string) {
    const date = new Date(timestamp)

    return `${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(
      date.getUTCDate()
    ).padStart(2, '0')}-${date.getUTCFullYear()} | ${String(
      date.getUTCHours()
    ).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(
      2,
      '0'
    )}:${String(date.getUTCSeconds()).padStart(2, '0')} (UTC)`
  }

  copyToClipboard(address: string) {
    this.$utils.copyToClipboard(address)
    this.$toast.info('system.info.copiedToClipboard')
  }

  tokenIconProps(direction: 'from' | 'to') {
    const isDeposit = this.isDepositSelected
    const isFrom = direction === 'from'
    const isNeo = (isDeposit && isFrom) || (!isDeposit && !isFrom)

    return {
      alt: isNeo ? 'neo icon' : 'neo X icon',
      src: isNeo
        ? require('@/assets/img/neo.svg')
        : require('@/assets/img/neox.svg'),
      class: isNeo
        ? 'bg-white rounded-full shadow-lg p-1'
        : 'bg-black rounded-full shadow-lg p-1',
    }
  }
}
